<div class="soft-card">
  <cdk-accordion>
    <cdk-accordion-item
      role="button"
      tabindex="0"
      #accordionItem="cdkAccordionItem"
      [expanded]="expanded()"
      [attr.aria-expanded]="accordionItem.expanded"
      class="flex flex-col"
    >
      <div
        class="font-semibold flex justify-between items-center cursor-pointer"
        (click)="accordionItem.toggle()"
      >
        <h6
          class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide"
        >
          {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.TITLE' | translate }}
        </h6>
        <div
          class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
        >
          @if (!accordionItem.expanded) {
          <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
          } @if (accordionItem.expanded) {
          <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
          }
        </div>
      </div>
      <div
        [style.display]="accordionItem.expanded ? 'block' : 'none'"
        class="pt-2 bg-surface"
      >
        <div class="flex flex-col bg-surface border-t border-t-solid border-t-separator">
          <div
            class="flex px-4 py-2 items-center w-full border-b border-b-solid border-b-separator bg-surface-secondary"
          >
            <div class="w-2/4 text-[0.825rem] font-semibold">
              {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.STOCK' | translate }}
            </div>
            <div
              class="w-1/4 text-[0.825rem] font-semibold flex items-center justify-end text-right"
            >
              {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.AMOUNT' | translate }}
            </div>
            <div
              class="w-1/4 text-[0.825rem] font-semibold flex items-center justify-end text-right"
            >
              {{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.DISPO' | translate }}
            </div>
          </div>
          @for (stockEntry of data()?.stockAmount; track stockEntry) {
          <div
            class="flex px-4 py-3 items-start w-full border-b border-b-solid border-b-separator"
          >
            <div class="w-2/4 flex items-start gap-2">
              <div
                (click)="showBewegungen.emit({stockLocation: stockEntry})"
                class="border border-primary bg-primary-50 hover:bg-primary-100 text-primary rounded-full p-3 cursor-pointer"
              >
                <soft-icon name="fa-regular fa-clipboard-list"></soft-icon>
              </div>
              <div class="flex flex-col gap-0.5">
                {{ stockEntry.stock?.title || stockEntry.stock?.name }}
                <div class="flex flex-col gap-0.5 mt-2">
                  @if ( showNextOrderDate() && stockEntry?.nextOrderDeliveryDate ) {
                  <span class="text-light text-sm"
                    >{{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.NEXT_DELIVERY' | translate |
                    interpolate : { date: stockEntry?.nextOrderDeliveryDate | format:
                    'DATE.DEFAULT', } }}</span
                  >
                  }
                  <span class="text-light text-sm"
                    >{{ '#ARTIKELINFO.PAGES.DETAIL.STOCK.ORDER_AMOUNT' | translate }} {{
                    stockEntry?.orders || 0 | number: '1.2-2' }} {{
                    stockEntry?.itemUnit?.name }}</span
                  >
                </div>
              </div>
            </div>
            <div class="w-1/4 font-semibold flex items-center justify-end text-right">
              {{ stockEntry.amount | number: '1.2-2' }} {{ stockEntry?.itemUnit?.name }}
            </div>
            <div class="w-1/4 font-semibold flex items-center justify-end text-right">
              {{ stockEntry.amount - stockEntry.reserved + stockEntry.orders | number:
              '1.2-2' }} {{ stockEntry?.itemUnit?.name }}
            </div>
          </div>
          }
        </div>
      </div>
    </cdk-accordion-item>
  </cdk-accordion>
</div>
